"use strict";
/*
 * Created on 09 02 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var CodebookLookupSequence_1 = require("../../../core/model/codebook/CodebookLookupSequence");

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../../core/model/DomainObject");

var ValidationResult_1 = require("../../../core/model/errors/ValidationResult");

var ProgressMonitorKind_1 = require("../../../core/model/ProgressMonitorKind");

var PriceTermination_1 = require("../../../price-termination/model/PriceTermination"); // tslint:disable:max-classes-per-file

/**
 * <p>Distinguishes monitors related to asynchronous process of terminating {@link SiteReleaseTermination}.</p>
 *
 * @author Jaroslav Sevcik
 */


var SiteReleaseTerminationMonitor =
/*#__PURE__*/
function (_ProgressMonitorKind_) {
  _inherits(SiteReleaseTerminationMonitor, _ProgressMonitorKind_);

  function SiteReleaseTerminationMonitor() {
    _classCallCheck(this, SiteReleaseTerminationMonitor);

    return _possibleConstructorReturn(this, _getPrototypeOf(SiteReleaseTerminationMonitor).apply(this, arguments));
  }

  _createClass(SiteReleaseTerminationMonitor, [{
    key: "validate",

    /**
     * @inheritDoc
     */
    value: function validate() {
      return true;
    }
  }]);

  return SiteReleaseTerminationMonitor;
}(ProgressMonitorKind_1.ProgressMonitorKind);

exports.SiteReleaseTerminationMonitor = SiteReleaseTerminationMonitor;
SiteReleaseTerminationMonitor.TAG = ProgressMonitorKind_1.ProgressMonitorKind.register(SiteReleaseTerminationMonitor);
/**
 * @author Jaroslav Sevcik
 */

var SiteReleaseTermination =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SiteReleaseTermination, _DomainObject_1$Domai);

  /**
   * Ctor.
   *
   * @param id Identification of termination record.
   * @param name The name of the record entered by user.
   * @param state The overall state of termination record.
   * @param terminationIssued The moment the user confirmed termination of selected records and termination has begun.
   * @param progressId Identification of progress related to this termination process. Most probably this will be only in use for
   *        processing of confirmation of the entire termination. If there is no termination process in run, there will be no reference.
   * @param validation Validation result aggregated to entire process.
   *        May aggregate summary info in case of errors within some {@link SelloutTerminationItem items}.
   */
  function SiteReleaseTermination(id, name, state, terminationIssued, progressId, validation) {
    var _this;

    _classCallCheck(this, SiteReleaseTermination);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SiteReleaseTermination).call(this));
    _this.id = id;
    _this.name = name;
    _this.state = state;
    _this.terminationIssued = terminationIssued;
    _this.progressId = progressId;
    _this.validation = validation;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(SiteReleaseTermination, [{
    key: "isEditable",
    value: function isEditable() {
      return this.state === PriceTermination_1.PriceTerminationState.Opened;
    }
  }]);

  return SiteReleaseTermination;
}(DomainObject_1.DomainObject);

exports.SiteReleaseTermination = SiteReleaseTermination;

SiteReleaseTermination.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(SiteReleaseTermination.name);
  return {
    id: builder.id('id'),
    name: builder.str('name'),
    // TODO: add sequence
    state: builder.senum('state', PriceTermination_1.PriceTerminationState, CodebookLookupSequence_1.CodebookLookupSequence.PriceTerminationStates),
    terminationIssued: builder.opt(builder.date('terminationIssued')),
    progressId: builder.opt(builder.str('progressId')),
    validation: builder.obj('validation', ValidationResult_1.ValidationResult.schema, function (mat) {
      return new ValidationResult_1.ValidationResult(mat.resultObjects);
    })
  };
}();